<template>
  <nav class="navbar navbar-expand-lg navbar-light">
    <div class="container-fluid">
      <a class="navbar-brand" href="">{{routeName}}</a>
      <button class="navbar-toggler navbar-burger"
              type="button"
              @click="toggleSidebar"
              :aria-expanded="$sidebar.showSidebar"
              aria-label="Toggle navigation">
        <span class="navbar-toggler-bar"></span>
        <span class="navbar-toggler-bar"></span>
        <span class="navbar-toggler-bar"></span>
      </button>
      <div class="collapse navbar-collapse">
        <ul class="navbar-nav ml-auto">
          
          <!--<li class="nav-item">-->
            <drop-down class="nav-item"
                     :title="username"
                     title-classes="nav-link">
                    <router-link to='/profile'>
                      <a href="#" class="nav-link">
                        <i class="ti-settings"></i>
                        <p>
                          Profile
                        </p>
                      </a>
                    </router-link>
                      <a  class="nav-link" @click="logout">
                        <i class="ti-angle-double-left"></i>
                        <p>
                          Logout
                        </p>
                      </a>
            </drop-down>
          <!--</li>-->
          <!--<b-dropdown right id="dropdown-1" :text="username">
            <template v-slot:button-content>
              <p-button round>{{username}}</p-button>
            </template>
            <b-dropdown-item>
              <router-link to='/profile'>
                      <a href="#" class="nav-link">
                        <i class="ti-settings"></i>
                          Profile
                      </a>
                    </router-link>
            </b-dropdown-item>
            <b-dropdown-item>
              <a  class="nav-link" @click="logout">
                        <i class="ti-angle-double-left"></i>
                          Logout
                      </a>
            </b-dropdown-item>
          </b-dropdown>-->
          <!--<drop-down class="nav-item"
                     :title="username"
                     title-classes="nav-link"
                     icon="ti-bell">
                    <router-link to='/profile'>
                      <a href="#" class="nav-link">
                        <i class="ti-settings"></i>
                        <p>
                          Profile
                        </p>
                      </a>
                    </router-link>
                    
                      <a  class="nav-link" @click="logout">
                        <i class="ti-angle-double-left"></i>
                        <p>
                          Logout
                        </p>
                      </a>
          </drop-down>-->
          
          <!--<li class="nav-item">
            <router-link to='/user'>
            <a href="#" class="nav-link">
              <i class="ti-settings"></i>
              <p>
                Profile
              </p>
            </a>
            </router-link>
          </li>-->
        </ul>
        
      </div>
    </div>
	</nav>
</template>
<script>

import { mapGetters } from "vuex";

export default {
  computed: {
    routeName() {
      const { name } = this.$route;
      return this.capitalizeFirstLetter(name);
    },
    ...mapGetters([
      'username'
    ])
  },
  data() {
    return {
      activeNotifications: false
    };
  },
  methods: {
    logout: function () {
        this.$store.dispatch('logout')
        //.then(() => {
          //this.$router.push('/login');
        //})
    },
    capitalizeFirstLetter(string) {
      return string.charAt(0).toUpperCase() + string.slice(1);
    },
    toggleNotificationDropDown() {
      this.activeNotifications = !this.activeNotifications;
    },
    closeDropDown() {
      this.activeNotifications = false;
    },
    toggleSidebar() {
      this.$sidebar.displaySidebar(!this.$sidebar.showSidebar);
    },
    hideSidebar() {
      this.$sidebar.displaySidebar(false);
    }
  }
};
</script>
<style>
</style>
